"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagDO = function FlagDO(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.51-16.07H-185.94A7.06,7.06,0,0,1-193-23.13v-91.81a7.06,7.06,0,0,1,7.06-7.06H-23.51a7.06,7.06,0,0,1,7.06,7.06v91.81a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H47.11a7.07,7.07,0,0,1-7.06-7.06V47.49a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-16.07H47.11a7.06,7.06,0,0,1-7.06-7.06v-91.81A7.06,7.06,0,0,1,47.11-122H209.54a7.06,7.06,0,0,1,7.06,7.06v91.81a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.51,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V47.49a7.06,7.06,0,0,1,7.06-7.06H-23.51a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.75,32.32s4.21,1.54,3.66,6.84l1.71,0S12,33,11.16,32.27s-3.41,0-3.41,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#64b496"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,31.5a30.86,30.86,0,0,1-8.2-.89,7,7,0,0,0,1.75-5c0-4.2-2.9-1.52-2.9-1.52S.72,25.71,1.87,30a16.89,16.89,0,0,1-3.3-1.69,15.43,15.43,0,0,0,2.75-5.82s-4.82-1-6.14,2.68A16.72,16.72,0,0,1-6.9,21.7c1.24,0,3-.8,3-5.52,0,0-3.15,0-4,2.74a28.14,28.14,0,0,1-.77-3.66c1.26.36,4.51.63,4.51-6.43,0,0-3.91,0-4.81,3.47,0-.89-.07-1.8-.06-2.74A7.6,7.6,0,0,0-4.81,1.91,9.17,9.17,0,0,0-8.26,3.7a6.14,6.14,0,0,0-2.41-6.26s-2.39,4.24,1.1,7.67a7.5,7.5,0,0,0-.79,1.46,7.42,7.42,0,0,0-4.07-3s-.93,5.66,4.36,8A30.08,30.08,0,0,0-8.54,20.4a18.8,18.8,0,0,1-2.74-3.17c0-6.3-5.16-6.46-5.16-6.46-1,7.19,4.35,7.48,4.35,7.48l2.91,3.18c-6.3-1.05-6.3,4.19-6.3,4.19,4.2,1.06,6.3-1,6.3-1l2.27,1.16c-4,.12-5.42,4.08-5.42,4.08a19.09,19.09,0,0,0,10-.84C2.79,32.54,9.07,32.55,12,32.55v-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#64b496"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.62,31.5a30.82,30.82,0,0,0,8.2-.89,7,7,0,0,1-1.74-5c0-4.2,2.89-1.52,2.89-1.52s1.9,1.6.75,5.88A16.62,16.62,0,0,0,25,28.3a15.3,15.3,0,0,1-2.74-5.82s4.82-1,6.13,2.68a16.72,16.72,0,0,0,2.08-3.46c-1.24,0-3-.8-3-5.52,0,0,3.15,0,4,2.74a26.57,26.57,0,0,0,.77-3.66c-1.25.36-4.5.63-4.5-6.43,0,0,3.9,0,4.8,3.47.05-.89.07-1.8.06-2.74A7.62,7.62,0,0,1,28.4,1.91,9.17,9.17,0,0,1,31.85,3.7a6.15,6.15,0,0,1,2.42-6.26s2.39,4.24-1.11,7.67A7.5,7.5,0,0,1,34,6.57a7.42,7.42,0,0,1,4.07-3s.93,5.66-4.36,8a30.08,30.08,0,0,1-1.53,8.78,18.8,18.8,0,0,0,2.74-3.17c0-6.3,5.16-6.46,5.16-6.46,1,7.19-4.35,7.48-4.35,7.48l-2.91,3.18c6.3-1.05,6.3,4.19,6.3,4.19-4.2,1.06-6.3-1-6.3-1L30.5,25.74c4,.12,5.42,4.08,5.42,4.08a19.11,19.11,0,0,1-10-.84c-5.1,3.56-11.38,3.57-14.28,3.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#64b496"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.91-14.26a36,36,0,0,0-9.57,8.94l3.38,2.49a32,32,0,0,1,8.44-7.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.81,13H26.5v8.4a4.2,4.2,0,0,1-4.2,4.2H16a5.23,5.23,0,0,0-4.2,2.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff6b71"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15,3.59V-8H30.7l-4.2,4.2V7.79H15Zm0,0",
    transform: "translate(194 123)",
    fill: "#5f64b9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.26",
    y: "130.78",
    width: "5.25",
    height: "5.25",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.81,13H-2.88v8.4a4.2,4.2,0,0,0,4.2,4.2H7.61a5.21,5.21,0,0,1,4.2,2.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff6b71"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.19,25.88a5.28,5.28,0,0,1,2.6,1.85h.05a5.24,5.24,0,0,1,2.6-1.85V17.23H9.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.66,3.59V-8H-7.08l4.2,4.2V7.79H8.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#5f64b9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "191.12",
    y: "130.78",
    width: "5.25",
    height: "5.25",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.37-2.71V.44l3.15,2.1V.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.52.44V3.59l4.19,2.1V4.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.26-2.71V.44l-3.15,2.1V.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.11.44V3.59l-4.2,2.1V4.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.14,20.38H5.48A5.23,5.23,0,0,1,.27,15.13V-1.1L11.89,6.73,23.35-1.1V15.13a5.23,5.23,0,0,1-5.21,5.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.46,1.49.27-1.66V9.88L4.46,12Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.16,1.49l4.19-3.15V9.88L19.16,12Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "199.51",
    y: "134.99",
    width: "12.59",
    height: "5.25",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.52,2.54l6.29,3.15,6.3-3.15V12H5.52Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.54,3.53V14.08A1.58,1.58,0,0,1,15,15.66H8.66a1.58,1.58,0,0,1-1.57-1.58V3.57L3.94,1.46V14.08A4.72,4.72,0,0,0,8.66,18.8H15a4.72,4.72,0,0,0,4.72-4.72V1.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.63,10.86a23.92,23.92,0,0,0-5.82,1.05A23.84,23.84,0,0,0,6,10.86c-3-.27-4.71-.52-5.72-2.31v3c1.54,1,3.5,1.19,5.53,1.37A20.79,20.79,0,0,1,11.44,14l.37.15.37-.15A21.18,21.18,0,0,1,17.82,13c2-.18,4-.36,5.54-1.37v-3c-1,1.8-2.76,2.05-5.73,2.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.91,1H12.34V-.61H11.29V1H9.71V2h1.58V6.73h1.05V2h1.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.46-3.22,2-3.8l9.23,9.22L10.69,6Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0-5.24l1.16,2.3L2.33-4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.5-4.82l.66-.47L11.84,5.25l-.66.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.38-7l.78,2.46,1.32-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.26-1.21l.47-.67L10.9,5.59l-.46.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2-2.93-.49-.87.44-2.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.93,6l-.58-.57,9.23-9.23.58.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.6-5.24l-1.16,2.3L21.29-4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.44,5.72l-.65-.48L19.47-5.31l.65.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.24-7l-.78,2.46-1.32-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.19,6.27l-.46-.67,10.7-7.46.46.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.65-2.93,24.11-.87,23.18-2.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.28,25.33S7.22,21,8,17c.63-3.22,2.55-6.77,4.06-7.63,0,0,2.12-.13,1.59,1.71s-1.18,2.33-1,4.15c.33,3.15.84,6.88-1.38,10.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.51,9.36a3,3,0,0,0-.45,0C10.56,10.2,8.64,13.75,8,17A8.17,8.17,0,0,0,9.1,22.2c-.51-6.6,1.42-8.94,3.41-12.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.66,15.2c-.19-1.82.46-2.3,1-4.15.37-1.29-.56-1.61-1.15-1.69a19.17,19.17,0,0,0-1.44,5.21c-.08,1.83.39,9.31.21,10.76,2.22-3.25,1.71-7,1.38-10.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.91,10.92a3.68,3.68,0,0,1,3.2-1q-.82-2.67-1.66-5.34a3.69,3.69,0,0,0-3.2,1c.55,1.77,1.11,3.55,1.66,5.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f0f0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.11,9.93a3.68,3.68,0,0,1,3.2-1q-.82-2.65-1.66-5.33a3.71,3.71,0,0,0-3.2,1c.55,1.78,1.11,3.56,1.66,5.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7-13.14A31.81,31.81,0,0,0-9.28-9.08l-2.05-3.66a35.92,35.92,0,0,1,18.44-4.6L7-13.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#5f64b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.53-14.26A35.88,35.88,0,0,1,39.1-5.32L35.72-2.83a32,32,0,0,0-8.44-7.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6-13.14A31.81,31.81,0,0,1,32.9-9.08L35-12.74a36,36,0,0,0-18.45-4.6c0,1.41.06,2.8.09,4.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#5f64b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.21-14.26a31.92,31.92,0,0,0-16.8,0c-.36-1.35-.73-2.7-1.1-4a36.07,36.07,0,0,1,19,0l-1.11,4Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.25,32.79a76.6,76.6,0,0,0-13.23,4.78l1.79,3.8A71.57,71.57,0,0,1-.92,36.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff6b71"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.88,32.79A76.5,76.5,0,0,1,39.1,37.57l-1.79,3.8a71.29,71.29,0,0,0-12.77-4.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff6b71"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.7,36A72,72,0,0,0-4.89,36c-.33-1.36-.65-2.72-1-4.08a76,76,0,0,1,35.55,0c-.33,1.36-.66,2.72-1,4.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.81,37.17l-2.89.73a1.06,1.06,0,0,1-1.31-1V35.37a1.06,1.06,0,0,1,1.31-1l2.89.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.81,35.07l2.9-.72a1,1,0,0,1,1.3,1v1.51a1,1,0,0,1-1.3,1l-2.9-.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,37.17h-.45a.83.83,0,0,1-.83-.82V35.9a.83.83,0,0,1,.83-.83H12a.83.83,0,0,1,.82.83v.45a.82.82,0,0,1-.82.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff6b71"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagDO;
exports["default"] = _default;